import { useEffect } from 'react';
import { colors } from '../../colors';
import { CloseIcon } from '../../icons/close';
import { PopupProps } from './dto';

export function PopupForm(props: PopupProps) {
    const { children, close, width, disableClose } = props

    useEffect(() => {
        const handleKeyDown = (event: KeyboardEvent) => {
            if (event.key === 'Escape' && !disableClose) close();
        };
        document.addEventListener('keydown', handleKeyDown);
        return () => document.removeEventListener('keydown', handleKeyDown);
    }, [close, disableClose]);

    return (
        <div className="fixed inset-0 z-[200] flex items-center justify-center">
            <div
                className="absolute inset-0 bg-black/40 backdrop-blur-sm"
                onClick={disableClose ? undefined : close}
            />
            <div
                className="relative z-10 flex flex-col bg-white rounded-2xl shadow-2xl overflow-hidden"
                style={{ width: width ? '1000px' : '800px', maxWidth: '95vw', maxHeight: '90vh' }}
            >
                <div className="flex items-center justify-between px-6 py-4 bg-brandPrimary-600">
                    <h2
                        style={{ fontFamily: 'Manrope' }}
                        className="text-white font-semibold text-base"
                    >
                        {props.title}
                    </h2>
                    <button
                        onClick={disableClose ? undefined : close}
                        disabled={disableClose}
                        className={`text-white/70 transition-colors p-2 rounded-lg ${disableClose ? 'cursor-not-allowed opacity-60' : 'hover:text-white hover:bg-white/10'}`}
                    >
                        <CloseIcon size={16} color={colors.white} />
                    </button>
                </div>
                <div className="flex-1 overflow-y-auto">
                    {children}
                </div>
            </div>
        </div>
    )
}